<template id="dropdown-template">
  <div class="relative">
    <div role="button" @click="toggle">
      <slot name="button"></slot>
    </div>
    <div v-show="show" class="absolute rounded z-30 bg-white shadow" :class="styles">
      <div class="px-2 py-2 text-sm text-grey-darker">
        <slot name="items"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  template: '#dropdown-template',
  props: {
    styles: {
      type: String,
      default: 'pin-r mt-1 w-48'
    }
  },
  created() {
    window.addEventListener('click', this.close);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close);
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    toggle: function() {
      this.show = !this.show;
    },
    close: function(event) {
      if (!this.$el.contains(event.target)) {
        this.show = false;
      }
    }
  }
};
</script>
